import { Component, Input, OnDestroy } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { first } from 'lodash-es';
import { Observable, of, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TaskListHeader, TaskListOperation } from 'src/app/models/domain';
import { OperationsService } from 'src/app/state';

export type IExpandable<P> = P & {
  expand: boolean;
};

export type IExpandableTaskListOperation = IExpandable<TaskListOperation>;

@Component({
  selector: 'em-operations-table',
  templateUrl: './operations-table.component.html',
  standalone: false,
})
export class OperationsTableComponent implements OnDestroy {
  public selectedOperation?: TaskListOperation;

  @Input() public parentId?: string;
  @Input() public loading = false;

  public operations$?: Observable<TaskListOperation[]>;
  public operationsUiState$ = this.operationsService.uiById$;

  public readonly trackByRef = trackByRef;

  private taskListHeaderValue?: TaskListHeader;
  private readonly subscriptions = new Subscription();

  public constructor(private readonly operationsService: OperationsService) {}

  @Input() public set taskListHeader(taskListHeader: TaskListHeader | undefined) {
    this.taskListHeaderValue = taskListHeader;

    this.operations$ = taskListHeader
      ? this.operationsService.operationsFor(taskListHeader).pipe(
          tap((operations) => {
            this.selectedOperation = first(operations);

            if (!this.selectedOperation) {
              return;
            }

            this.subscriptions.add(
              this.operationsService
                .populateCharacteristicsByOperation(this.selectedOperation)
                .subscribe()
            );
          })
        )
      : of([]);
  }

  public get taskListHeader() {
    return this.taskListHeaderValue;
  }

  public operationSelectionChange(operation: TaskListOperation) {
    this.subscriptions.add(
      this.operationsService.populateCharacteristicsByOperation(operation).subscribe()
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
